const getGaClientId = function (gaAccount, ga) {
    let gaClientId = '';
    if (gaAccount && ga) {
        ga('create', gaAccount, 'auto');
        ga((tracker) => {
            gaClientId = tracker.get('clientId');
        });
    }
    return gaClientId;
};
export default getGaClientId;
